import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import SmsIntegrationForm from "./SmsIntegrationComponents/SmsIntegrationForm";

import {
  useGetSmsIntegrationDetailQuery,
  useUpdateSmsIntegrationMutation,
} from "store/services/smsIntegrationApi";

import { useAppMeta } from "hooks";

const SmsIntegrationEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "SMS Integrations", path: "/app/crm/sms-integrations/list" },
    { title: "Edit SMS Integration" },
  ];

  const {
    data: smsIntegrationDetail,
    isLoading: loadingSmsIntegration,
    error,
  } = useGetSmsIntegrationDetailQuery(id);

  const [updateSmsIntegration, { isLoading: updatingSmsIntegration }] =
    useUpdateSmsIntegrationMutation();

  const handleUpdateSmsIntegration = async (data) => {
    try {
      await updateSmsIntegration({ _id: id, ...data }).unwrap();
      toast.success("SMS Integration successfully updated!");
      navigate(`/app/crm/sms-integrations/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update SMS Integration!"
      );
    }
  };

  useAppMeta("Edit SMS Integration");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingSmsIntegration || updatingSmsIntegration}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <SmsIntegrationForm
          isBusy={loadingSmsIntegration || updatingSmsIntegration}
          smsIntegrationDetail={smsIntegrationDetail}
          onSubmit={handleUpdateSmsIntegration}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SmsIntegrationEditScreen;